import React, { useState, useEffect, useCallback } from "react";
import "../../Styles/yellocalfcss/AssetsRegisterReport.css";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import ScaleLoader from "react-spinners/ScaleLoader";

const Assets_Register_Report = () => {
  const customer_currency = (localStorage.getItem("customer_currency") || "").replace(/"/g, "");
  // 1. State management
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [assetType, setAssetType] = useState("");
  const [startDate, setStartDate] = useState("2025-01-01");
  const [endDate, setEndDate] = useState("2026-12-31");

  // State for dynamic dropdown options
  const [assetTypeList, setAssetTypeList] = useState([]);

  // Fetch Dropdown Options
  const fetchTypeDropdown = async () => {
    try {
      const payload = {
        customer_id: Number(localStorage.getItem("customer_id")),
        api_key: localStorage.getItem("api_key"),
        user_id: localStorage.getItem("user_id") || "56950",
      };

      const res = await simplePostCall(
        ApiConfig.typesdropdownAssies,
        JSON.stringify(payload)
      );

      if (res && res.result && res.data) {
        setAssetTypeList(res.data);
      }
    } catch (err) {
      console.error("Error fetching dropdown types:", err);
    }
  };

  const fetchInitialData = useCallback(async () => {
    setLoading(true);
    try {
      const payload = {
        customer_id: Number(localStorage.getItem("customer_id")) || 1005,
        api_key: localStorage.getItem("api_key") || "b9359f494e77b6589ce12dd62518c585",
        language: "en",
        user_id: localStorage.getItem("user_id") || 14857,
        page: 1,
        limit: 99999999999,
        start_date: startDate,   // ✅ now dynamic
        end_date: endDate,        // ✅ now dynamic
        asset_type: assetType,
        search: "",
      };

      console.log("Fetching with payload:", payload); // helpful for debugging

      const response = await simplePostCall(
        ApiConfig.assetmodereportports,
        JSON.stringify(payload)
      );

      if (response && response.result && response.data) {
        setReportData(response.data);
      } else {
        setReportData([]);
      }
    } catch (error) {
      console.error("Error fetching report:", error);
      setReportData([]);
    } finally {
      setLoading(false);
    }
  }, [assetType, startDate, endDate]); // ✅ all three as dependencies

  // Initial mount: Fetch dropdown list
  useEffect(() => {
    fetchTypeDropdown();
  }, []);

  // Fetch report when filters change
  useEffect(() => {
    fetchInitialData();
  }, [fetchInitialData]);

  const totalAmount = reportData.reduce(
    (sum, item) => sum + Number(item.asset_amount || 0),
    0
  );

  const handleClear = () => {
    setAssetType("");
    setStartDate("2025-01-01"); // ✅ reset start date too
    setEndDate("2026-12-31");
  };

  return (
    <div className="assets_register_report-container" style={{ paddingTop: "25px" }}>
      <div className="assets_register_report-header">
        <h3 className="assets_register_report-title">Assets Register Report</h3>
        <button style={{ backgroundColor: "#5db2e8" }} className="btn btn-sm text-white">
          Export
        </button>
      </div>

      <div className="assets_register_report-row">
        <div className="assets_register_report-col">
          <div className="assets_register_report-panel">
            <div className="assets_register_report-panel-body">
              <div className="assets_register_report-table-responsive">
                <table className="assets_register_report-table">
                  <thead>
                    <tr className="assets_register_report-filters">
                      <td colSpan="6">
                        <div className="row g-2 align-items-center mb-3">
                          {/* Asset Type Dropdown */}
                          <div className="col">
                            <select
                              className="form-select"
                              value={assetType}
                              onChange={(e) => setAssetType(e.target.value)}
                            >
                              <option value="">All Types</option>
                              {assetTypeList.map((type, idx) => (
                                <option key={idx} value={type.value}>
                                  {type.label}
                                </option>
                              ))}
                            </select>
                          </div>

                          {/* Start Date */}
                          <div className="col">
                            <input
                              type="date"
                              className="form-control"
                              value={startDate}
                              onChange={(e) => setStartDate(e.target.value)}
                            />
                          </div>

                          {/* Separator */}
                          <div className="col-auto">
                            <span style={{ color: "#888" }}>to</span>
                          </div>

                          {/* End Date */}
                          <div className="col">
                            <input
                              type="date"
                              className="form-control"
                              value={endDate}
                              onChange={(e) => setEndDate(e.target.value)}
                            />
                          </div>

                          {/* Clear Button */}
                          <div className="col-auto">
                            <button
                              onClick={handleClear}
                              className="btn text-white"
                              style={{ backgroundColor: "#5db2e8", border: "none" }}
                            >
                              Clear
                            </button>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th style={{ textAlign: "center" }}>Sr</th>
                      <th style={{ textAlign: "center" }}>Asset Type</th>
                      <th style={{ textAlign: "center" }}>Asset Name</th>
                      <th style={{ textAlign: "center" }}>Description</th>
                      <th style={{ textAlign: "center" }}>Date</th>
                      <th style={{ textAlign: "center" }}>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan="6" className="text-center">
                          <ScaleLoader color="#F4BB44" />
                        </td>
                      </tr>
                    ) : reportData.length > 0 ? (
                      reportData.map((item, index) => (
                        <tr key={item.asset_id || index}>
                          <td>{index + 1}</td>
                          <td>{item.asset_type}</td>
                          <td>{item.asset_name}</td>
                          <td>{item.asset_description}</td>
                          <td>{new Date(item.asset_date).toLocaleDateString()}</td>
                          <td>{customer_currency}{Number(item.asset_amount).toLocaleString()}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" style={{ textAlign: "center", padding: "20px" }}>
                          No records found.
                        </td>
                      </tr>
                    )}
                    {reportData.length > 0 && (
                      <tr className="fw-bold" style={{ backgroundColor: "#f8f9fa" }}>
                        <td colSpan="5" className="text-end">Total Amount</td>
                        <td>{customer_currency}{totalAmount.toLocaleString()}</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Assets_Register_Report;